import { render, staticRenderFns } from "./postWorkdaySetting.vue?vue&type=template&id=dd2bee5c&"
import script from "./postWorkdaySetting.vue?vue&type=script&lang=ts&"
export * from "./postWorkdaySetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports